module.exports = __webpack_public_path__ + "assets/img/correct-icon.e10d3cc4.svg";